function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.422 57.107l27.367-28.14a.508.508 0 00.062-.649c-1.665-2.33-4.735-2.735-5.873-4.3-3.372-4.64-4.227-7.265-5.676-7.102a.442.442 0 00-.262.139L7.153 27.22C1.466 33.068.65 45.944.5 56.725a.536.536 0 00.922.382z",
  fill: "#017CEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.433 56.411L29.38 28.96a.505.505 0 00-.647-.062c-2.324 1.67-2.727 4.75-4.288 5.892-4.625 3.381-7.242 4.24-7.08 5.693a.443.443 0 00.139.263l10.134 9.917c5.83 5.705 18.666 6.523 29.415 6.673a.538.538 0 00.38-.925z",
  fill: "#00AD46"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.638 50.663c-3.185-3.116-4.663-9.281 1.443-21.995-9.923 4.448-13.4 10.295-11.69 11.969l10.247 10.026z",
  fill: "#04D659"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.739.23L29.372 28.368a.508.508 0 00-.062.649c1.665 2.33 4.735 2.735 5.873 4.3 3.372 4.64 4.227 7.265 5.676 7.102a.442.442 0 00.262-.139l9.887-10.165C56.696 24.268 57.51 11.392 57.66.61a.536.536 0 00-.922-.38z",
  fill: "#00C7D4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.008 30.116c-3.107 3.194-9.253 4.676-21.927-1.448 4.434 9.953 10.263 13.441 11.932 11.725l9.995-10.277z",
  fill: "#11E1EE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M.729.925l28.053 27.45a.505.505 0 00.647.062c2.324-1.67 2.727-4.75 4.288-5.89 4.625-3.382 7.242-4.24 7.08-5.694a.445.445 0 00-.139-.263L30.524 6.673C24.694.968 11.857.15 1.109 0a.538.538 0 00-.38.925z",
  fill: "#E43921"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.524 6.673c3.184 3.116 4.662 9.281-1.443 21.995 9.922-4.448 13.4-10.295 11.689-11.969L30.524 6.673z",
  fill: "#FF7557"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.154 27.22c3.106-3.194 9.252-4.676 21.927 1.448-4.434-9.953-10.263-13.44-11.932-11.725L7.154 27.22z",
  fill: "#0CB6FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1 29.892a1.226 1.226 0 001.209-1.243 1.226 1.226 0 00-1.24-1.212 1.226 1.226 0 00-1.208 1.242c.009.678.563 1.22 1.24 1.213z",
  fill: "#4A4848"
});

function SvgAirflowLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirflowLogo);
export default __webpack_public_path__ + "static/media/airflow-logo.2ad2c47c.svg";
export { ForwardRef as ReactComponent };